import { createApp } from 'vue';
import './style.css';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import * as Sentry from '@sentry/vue';
import VueKonva from 'vue-konva';

const pinia = createPinia();
const app = createApp(App);


if (import.meta.env.VITE_SENTRY_DSN) {
    console.log('Sentry DSN is set, initializing Sentry');
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        sendDefaultPii: true,
        integrations: [
            Sentry.replayIntegration(),
            Sentry.browserTracingIntegration(),
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        tracesSampleRate: 1.0,
        tracePropagationTargets: ['localhost', /\.scoring\.aswseducation\.com/],
        enableLogs: true,
    });
}

app.use(router);
app.use(pinia);
app.use(VueQueryPlugin);
app.use(VueKonva);

app.mount('#app')
